import { DxoUiButton } from "./src/DxoUiButton.js";

export { DxoUiButton } from "./src/DxoUiButton.js";

if (!window.customElements.get("dxo-ui-button")) {
  window.customElements.define("dxo-ui-button", DxoUiButton);
}
